import Vue from 'vue'

import { addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import datetime from "@/extension/date-time"

addCustomWidgetSchema({
  type: 'datetime',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: '',
    defaultValue: '',
    label: '时间',
    labelAlign: 'label-right-align',
    size: '',
    columnWidth: '200px',
    labelWidth: '110',
    required: false,
    disabled: false,
    labelHidden: false,
    clearable: true,
    placeholder: '选择日期',
    customClass: '',
    dateWidth: '60%',
    mWidth: '20%',
    sWidth: '20%',
    currentDateVisible: true, //显示当前时间
    futureDateDisabled: true, //禁用未来时间
    pastDateDisabled: false, //禁用过去时间
    valueFormat: 'YYYY-MM-DD HH:mm',  //日期对象格式
    onCreated: '',
    onMounted: '',
    onChange: '',
    onBlur: ''
  }
})  //加载组件Json Schema

Vue.component(datetime.name, datetime)  //注册组件

// 注册属性编辑框

PERegister.registerCPEditor('dateWidth', 'dateWidth-editor',
  PEFactory.createInputTextEditor('dateWidth', '日期控件长度'))

PERegister.registerCPEditor('mWidth', 'mWidth-editor',
  PEFactory.createInputTextEditor('mWidth', '小时控件长度'))

PERegister.registerCPEditor('sWidth', 'sWidth-editor',
  PEFactory.createInputTextEditor('sWidth', '分钟控件长度'))

PERegister.registerCPEditor('currentDateVisible', 'currentDateVisible-editor',
  PEFactory.createBooleanEditor('currentDateVisible', '默认当前时间'))

PERegister.registerCPEditor('futureDateDisabled', 'futureDateDisabled-editor',
  PEFactory.createBooleanEditor('futureDateDisabled', '禁用未来日期'))

PERegister.registerCPEditor('pastDateDisabled', 'pastDateDisabled-editor',
  PEFactory.createBooleanEditor('pastDateDisabled', '禁用过去日期'))
